<script setup>
import TranslationValue from '@/components/layouts/TranslationValue.ce.vue';
import {useTranslationsStore} from "@/store/translations";
import {storeToRefs} from "pinia";
import {useApiResponsesStore} from "@/store/responses";
import {computed} from "vue";

const translationStore = useTranslationsStore();
const { languageCode } = storeToRefs(translationStore);

const apiResponsesStore = useApiResponsesStore();
const { regionResponses } = storeToRefs(apiResponsesStore);

const currentDate = new Date();

const publicationDate = computed(() => {
    if (regionResponses.value.quarterlyLivingWages) {
        const dateString = regionResponses.value.quarterlyLivingWages['publication_date'];
        return new Date(dateString);
    }
    return null;
});

function localizeDate(date) {
    let options = {
        year: 'numeric',
        month: 'long',
    };

    let dateFormatter = new Intl.DateTimeFormat(languageCode, options);
    return dateFormatter.format(date);
}

</script>

<template>
<ul
    class="mt-4 text-xs text-slate-600"
    v-if="publicationDate"
>
    <li>
        <TranslationValue
            id="page1_latest"
            :context="{date: localizeDate(publicationDate)}"
        />
    </li>
    <li>
        <TranslationValue
            id="page1_valid"
            :context="{date: localizeDate(currentDate)}"
        />
    </li>
</ul>
</template>
